// File: WasteManagementAboutSection.jsx
// Pure CSS | Maintenance / Cleaning / Services Style

import { Music, Play, ShoppingBasket, ShoppingCart, Star, Watch } from 'lucide-react';
import React from 'react';
export default function AboutUsCard14() {
  return (<>
    <section className="wm-sec-ac-14">
      <div className="wm-left-ac-14">
        <div className="wm-icon-ac-14"><ShoppingCart size={80} color={"#222222"}/></div>
        <h2 className="wm-title-ac-14">ABOUT MAINTENANCE</h2>
        <p className="wm-text-ac-14">
          Replace this text with a short introduction. Explain what your maintenance or waste
          management company does, keeping it clear and impactful for your customers.
        </p>

        <div className="wm-feature-ac-14s-ac-14">
          <div className="wm-feature-ac-14">
            <span className="feat-icon-ac-14"><Watch size={30} color={"#222222"}/></span>
            <p>Services At Time</p>
          </div>
          <div className="wm-feature-ac-14">
            <span className="feat-icon-ac-14"><Music size={30} color={"#222222"}/></span>
            <p>Good Support</p>
          </div>
          <div className="wm-feature-ac-14">
            <span className="feat-icon-ac-14"><Star size={30} color={"#222222"}/></span>
            <p>25 Years Experience</p>
          </div>
        </div>

        <button className="wm-btn-ac-14">VIEW MORE ABOUT</button>
      </div>

      <div className="wm-right-ac-14">
         <div className="video-card-ac-14">
         
          <button className="play-btn-ac-14"><Play size={30}  color={"rgba(144, 202, 249,1)"}/></button>
             <div className="stat-ac-14s-box-ac-14">
          <div className="stat-ac-14">
            <span className="num-ac-14">50K+</span>
            <p>Global Happy Clients</p>
          </div>
          <div className="stat-ac-14">
            <span className="num-ac-14">16+</span>
            <p>Services</p>
          </div>
          <div className="stat-ac-14">
            <span className="num-ac-14">12+</span>
            <p>Years Experience</p>
          </div>
          <div className="stat-ac-14">
            <span className="num-ac-14">4.5+</span>
            <p>Rating</p>
          </div>
        </div>
        </div>
      </div>
    </section><style>{`
/* File: WasteManagementAboutSection.css */


/* LEFT */
.video-card-ac-14 {min-width: 500px;
  position: relative;min-height:380px;
  border-radius: 20px;
  overflow: hidden;
}
/* STATS CARD */
.stat-ac-14s-box-ac-14 {
  display: flex;
  gap: 20px;
  background: rgba(144, 202, 249,0.1);
  padding: 22px;
  border-radius: 18px;
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
}

.stat-ac-14 { text-align: center; flex: 1; }
.num-ac-14 {
  font-size: 26px;
  font-weight: 800;
  color: #222222;
}
.stat-ac-14 p {
  color: #333333;
  font-size: 13px;
  margin-top: 6px;
}

.play-btn-ac-14 {
  position: absolute;
  top: 50%;display:flex;justify-content:center;align-items:center;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80px;
  height: 80px;
  background:rgba(144, 202, 249,0.1);
  border: none;
  border-radius: 50%;
  color: #222;
  font-size: 32px;
  cursor: pointer;
  box-shadow: 0 0 10px rgba(144, 202, 249,0.5);
}

.wm-sec-ac-14 { margin-top:50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 40px;
  padding: 80px 80px;
  background: rgba(144, 202, 249,0.05);
  background-image: url('data:image/svg+xml,%3Csvg width=60 height=60 xmlns=http://www.w3.org/2000/svg%3E%3Cpath d="M5 10h50M10 5v50" stroke=%23e3e3e3 stroke-width=1/%3E%3C/svg%3E');
  font-family: Inter, sans-serif;
}

/* LEFT */
.wm-left-ac-14 { max-width: 520px; }

.wm-icon-ac-14 {
  font-size: 48px;
  color: rgba(144, 202, 249,1);
  margin-bottom: 12px;
}

.wm-title-ac-14 {
  font-size: 32px;
  font-weight: 800;
  color:#141414;
  margin-bottom: 18px;
}

.wm-text-ac-14 {
  color: #555;
  line-height: 1.7;
  font-size: 15px;
  margin-bottom: 30px;
}

.wm-feature-ac-14s-ac-14 {
  display: flex;
  gap: 24px;
  margin-bottom: 30px;
}

.wm-feature-ac-14 {
  text-align: center;
  font-size: 14px;
  font-weight: 600;
}

.feat-icon-ac-14 {
  display: block;
  font-size: 30px;
  margin-bottom: 8px;
  color:rgba(144, 202, 249,1);
}

/* BUTTON */
.wm-btn-ac-14 {
  background: rgba(144, 202, 249,1);
  border: none;
  padding: 14px 26px;
  color: #fff;
  font-weight: 700;
  border-radius: 40px;
  cursor: pointer;
}

/* RIGHT */
.wm-right-ac-14 {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.bin-placeholder {
  width: 380px;
  height: 420px;
  background: #f5f5f5;
  border: 2px dashed #ccc;
  border-radius: 10px;
  font-size: 24px;
  color: #aaa;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Responsive */
@media(max-width:960px){
.video-card-ac-14 {min-width:300px;min-height:300px;
    }

.play-btn-ac-14 {
  top: 70%;
 }
  .wm-sec-ac-14 { flex-direction: column; text-align: center; padding: 80px 10px;}
  .wm-feature-ac-14s-ac-14 { justify-content: center; flex-wrap: wrap; }
  .bin-placeholder { width: 100%; height: 300px; }
}`}</style>
    </>
  );
}

